import { UserLangCode } from "src/utils/util.types";
import { SessionStatisticsType } from "../types/statistics.entity";
import { BaseStatAggregator } from "./base/base-stat-aggregator";
import { sessionRepository } from "src/features/sessions/session.repsoitory";
import { Session } from "src/features/sessions/types/session.entity";

export class SessionStatsAggregator extends BaseStatAggregator {
  protected execQuery(statType: SessionStatisticsType, langCode?: UserLangCode): Promise<number> {
    // Determine state by prefix
    const state = statType.startsWith("COMPLETED") ? "COMPLETED" : statType.startsWith("MISSED") ? "MISSED" : undefined;

    // Determine type by infix
    let type: Session["type"] | undefined;
    if (statType.includes("BOOKED")) type = "BOOKING";
    else if (statType.includes("DIRECT")) type = "DIRECT";
    else if (statType.includes("LOUNGE")) type = "LOUNGE";

    return sessionRepository.count({ state, type, langCode });
  }
}

// protected execQuery(statType: StatisticsType, langCode?: UserLangCode): Promise<number> {
//   const state: Session["state"] | undefined =
//     statType == "COMPLETED_BOOKED_SESSIONS"
//       ? "COMPLETED"
//       : statType == "COMPLETED_DIRECT_SESSIONS"
//       ? "COMPLETED"
//       : statType == "COMPLETED_LOUNGE_SESSIONS"
//       ? "COMPLETED"
//       : statType == "COMPLETED_SESSIONS"
//       ? "COMPLETED"
//       : statType == "MISSED_BOOKED_SESSIONS"
//       ? "MISSED"
//       : statType == "MISSED_DIRECT_SESSIONS"
//       ? "MISSED"
//       : undefined;

//   const type: Session["type"] | undefined =
//     statType == "COMPLETED_BOOKED_SESSIONS"
//       ? "BOOKING"
//       : statType == "COMPLETED_DIRECT_SESSIONS"
//       ? "DIRECT"
//       : statType == "COMPLETED_LOUNGE_SESSIONS"
//       ? "LOUNGE"
//       : statType == "COMPLETED_SESSIONS"
//       ? undefined
//       : statType == "MISSED_BOOKED_SESSIONS"
//       ? "BOOKING"
//       : statType == "MISSED_DIRECT_SESSIONS"
//       ? "DIRECT"
//       : undefined;

//   return sessionRepository.count({
//     state,
//     type,
//     langCode,
//   });
// }
